export default __webpack_public_path__ + "static/media/stoptorture.a8776d4a.png";